import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';

export default {
  name: 'ABS',
  shortDescription: 'Absolute value of a number.',
  category: FunctionCategory.MATH,
  description: 'Returns the absolute value of a number.',
  params: [
    {
      name: 'value',
      type: ArgType.number,
      description: 'The number of which to return the absolute value.',
    },
  ],
  eval: (value: number): number => Math.abs(value),
} satisfies EvaluablePrimitiveSpreadsheetFunction;
